// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1P8ti","error":"Textarea_error__ue70R","readonly":"Textarea_readonly__39vl7","disabled":"Textarea_disabled__rJ4sh"};